import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ScheduleGuestCoverageForWeddingEventQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type ScheduleGuestCoverageForWeddingEventQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    guests: { __typename?: 'EventGuests'; id: string; peopleCount: number };
    info: {
      __typename?: 'EventInfo';
      id: string;
      schedule: {
        __typename?: 'EventScheduleInfo';
        id: string;
        items: Array<{
          __typename?: 'EventSchedule';
          id: string;
          isPublic: boolean;
          guests: { __typename?: 'EventScheduleGuests'; isInviteOnly: boolean; people: Array<{ __typename?: 'Person'; id: string }> };
        }>;
      };
    };
  } | null;
};

export type ScheduleGuestListTotalCountQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type ScheduleGuestListTotalCountQuery = { __typename?: 'Query'; getGuestListMembersByEventId: { __typename?: 'GuestListMemberConnection'; totalCount: number } };

export type ScheduleGuestNamesForWeddingEventQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type ScheduleGuestNamesForWeddingEventQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    guests: {
      __typename?: 'EventGuests';
      id: string;
      people: Array<{ __typename?: 'Person'; id: string; fullName?: string | null; avatar?: { __typename?: 'Photo'; id: string; url: string } | null }>;
    };
  } | null;
};

export type ScheduleGuestListMembersForCoverageQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type ScheduleGuestListMembersForCoverageQuery = {
  __typename?: 'Query';
  getGuestListMembersByEventId: {
    __typename?: 'GuestListMemberConnection';
    pageInfo: { __typename?: 'GuestListMemberPageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'GuestListMemberEdge';
      node: {
        __typename?: 'GuestListMember';
        id: string;
        contact: { __typename?: 'Contact'; id: string; firstName: string; lastName: string };
        tags: Array<{ __typename?: 'GuestListMemberTag'; tagDefinitionId: string }>;
      };
    }>;
  };
};

export const ScheduleGuestCoverageForWeddingEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleGuestCoverageForWeddingEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guests' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'peopleCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guests' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'isInviteOnly' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'people' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useScheduleGuestCoverageForWeddingEventQuery__
 *
 * To run a query within a React component, call `useScheduleGuestCoverageForWeddingEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleGuestCoverageForWeddingEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleGuestCoverageForWeddingEventQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useScheduleGuestCoverageForWeddingEventQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleGuestCoverageForWeddingEventQuery, ScheduleGuestCoverageForWeddingEventQueryVariables>,
) {
  return ApolloReactHooks.useQuery<ScheduleGuestCoverageForWeddingEventQuery, ScheduleGuestCoverageForWeddingEventQueryVariables>(
    ScheduleGuestCoverageForWeddingEventDocument,
    baseOptions,
  );
}
export function useScheduleGuestCoverageForWeddingEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleGuestCoverageForWeddingEventQuery, ScheduleGuestCoverageForWeddingEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ScheduleGuestCoverageForWeddingEventQuery, ScheduleGuestCoverageForWeddingEventQueryVariables>(
    ScheduleGuestCoverageForWeddingEventDocument,
    baseOptions,
  );
}
export type ScheduleGuestCoverageForWeddingEventQueryHookResult = ReturnType<typeof useScheduleGuestCoverageForWeddingEventQuery>;
export type ScheduleGuestCoverageForWeddingEventLazyQueryHookResult = ReturnType<typeof useScheduleGuestCoverageForWeddingEventLazyQuery>;
export type ScheduleGuestCoverageForWeddingEventQueryResult = Apollo.QueryResult<ScheduleGuestCoverageForWeddingEventQuery, ScheduleGuestCoverageForWeddingEventQueryVariables>;
export const ScheduleGuestListTotalCountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleGuestListTotalCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestListMembersByEventId' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useScheduleGuestListTotalCountQuery__
 *
 * To run a query within a React component, call `useScheduleGuestListTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleGuestListTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleGuestListTotalCountQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useScheduleGuestListTotalCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleGuestListTotalCountQuery, ScheduleGuestListTotalCountQueryVariables>) {
  return ApolloReactHooks.useQuery<ScheduleGuestListTotalCountQuery, ScheduleGuestListTotalCountQueryVariables>(ScheduleGuestListTotalCountDocument, baseOptions);
}
export function useScheduleGuestListTotalCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleGuestListTotalCountQuery, ScheduleGuestListTotalCountQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ScheduleGuestListTotalCountQuery, ScheduleGuestListTotalCountQueryVariables>(ScheduleGuestListTotalCountDocument, baseOptions);
}
export type ScheduleGuestListTotalCountQueryHookResult = ReturnType<typeof useScheduleGuestListTotalCountQuery>;
export type ScheduleGuestListTotalCountLazyQueryHookResult = ReturnType<typeof useScheduleGuestListTotalCountLazyQuery>;
export type ScheduleGuestListTotalCountQueryResult = Apollo.QueryResult<ScheduleGuestListTotalCountQuery, ScheduleGuestListTotalCountQueryVariables>;
export const ScheduleGuestNamesForWeddingEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleGuestNamesForWeddingEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guests' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useScheduleGuestNamesForWeddingEventQuery__
 *
 * To run a query within a React component, call `useScheduleGuestNamesForWeddingEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleGuestNamesForWeddingEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleGuestNamesForWeddingEventQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useScheduleGuestNamesForWeddingEventQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleGuestNamesForWeddingEventQuery, ScheduleGuestNamesForWeddingEventQueryVariables>,
) {
  return ApolloReactHooks.useQuery<ScheduleGuestNamesForWeddingEventQuery, ScheduleGuestNamesForWeddingEventQueryVariables>(ScheduleGuestNamesForWeddingEventDocument, baseOptions);
}
export function useScheduleGuestNamesForWeddingEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleGuestNamesForWeddingEventQuery, ScheduleGuestNamesForWeddingEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ScheduleGuestNamesForWeddingEventQuery, ScheduleGuestNamesForWeddingEventQueryVariables>(
    ScheduleGuestNamesForWeddingEventDocument,
    baseOptions,
  );
}
export type ScheduleGuestNamesForWeddingEventQueryHookResult = ReturnType<typeof useScheduleGuestNamesForWeddingEventQuery>;
export type ScheduleGuestNamesForWeddingEventLazyQueryHookResult = ReturnType<typeof useScheduleGuestNamesForWeddingEventLazyQuery>;
export type ScheduleGuestNamesForWeddingEventQueryResult = Apollo.QueryResult<ScheduleGuestNamesForWeddingEventQuery, ScheduleGuestNamesForWeddingEventQueryVariables>;
export const ScheduleGuestListMembersForCoverageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ScheduleGuestListMembersForCoverage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGuestListMembersByEventId' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contact' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tagDefinitionId' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useScheduleGuestListMembersForCoverageQuery__
 *
 * To run a query within a React component, call `useScheduleGuestListMembersForCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleGuestListMembersForCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleGuestListMembersForCoverageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useScheduleGuestListMembersForCoverageQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleGuestListMembersForCoverageQuery, ScheduleGuestListMembersForCoverageQueryVariables>,
) {
  return ApolloReactHooks.useQuery<ScheduleGuestListMembersForCoverageQuery, ScheduleGuestListMembersForCoverageQueryVariables>(
    ScheduleGuestListMembersForCoverageDocument,
    baseOptions,
  );
}
export function useScheduleGuestListMembersForCoverageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleGuestListMembersForCoverageQuery, ScheduleGuestListMembersForCoverageQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ScheduleGuestListMembersForCoverageQuery, ScheduleGuestListMembersForCoverageQueryVariables>(
    ScheduleGuestListMembersForCoverageDocument,
    baseOptions,
  );
}
export type ScheduleGuestListMembersForCoverageQueryHookResult = ReturnType<typeof useScheduleGuestListMembersForCoverageQuery>;
export type ScheduleGuestListMembersForCoverageLazyQueryHookResult = ReturnType<typeof useScheduleGuestListMembersForCoverageLazyQuery>;
export type ScheduleGuestListMembersForCoverageQueryResult = Apollo.QueryResult<ScheduleGuestListMembersForCoverageQuery, ScheduleGuestListMembersForCoverageQueryVariables>;
